module.exports = __webpack_public_path__ + "img/bg_sginin.483e1dc2.png";